module.exports = __webpack_public_path__ + "static/media/nextButton.4bf32aef.svg";